import {AxiosError} from 'axios';

export function axiosErrorFormatter(err: AxiosError, customMessage?: string) {
    let responseStatus = err.response?.status ?? -1;
    let message = err.response?.data?.message ?? err.message;
    let errorCode = err.response?.data?.errorCode ?? '';
    let errorMessage = err.response?.data?.errorMessage ?? '';
    let appMessage = customMessage ?? '';
    return `Service Error:  Status - (${responseStatus}) Message - (${message}) ErrorCode - (${errorCode}) ErrorMessage - (${errorMessage}) Custom Message (${appMessage})`;
}
